import React, { useEffect } from "react";
import Modal from "components/Modal";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { fetchSingleVideoDescriptionAction } from "redux/actions/fetchSingleVideoDescriptionAction";
import TabInfo from "./tabs/TabInfo";
import TabEdit from "./tabs/TabEdit";
import "./style.scss";

export default function VideoDescriptionDetails() {
    const [t] = useTranslation();
    const history = useHistory();
    const dispatch = useDispatch();
    const { videoDescription } = useSelector(state => state.video);
    const { videoId } = useParams();

    useEffect(() => {
        dispatch(fetchSingleVideoDescriptionAction(videoId));
    }, [dispatch, videoId]);

    const onClose = () => history.push("/videos");

    const tabs = [
        {
            tabName: "info",
            component: <TabInfo videoDescription={videoDescription} key="info" />
        },
        {
            tabName: "edit",
            component: <TabEdit videoDescription={videoDescription} onClose={onClose} />
        }
    ];

    return videoDescription && (
        <div className="organisation-detail">
            <Modal
                title={t("admin.video.introductions")}
                basePath={`/videos/video/${videoId}`}
                tabs={tabs}
                onClose={onClose}
            />
        </div>
    );
}
